export default { sha: '8aaf95c88eda1d29c7f75546548b2a5027712373', buildNumber: 'undefined' }
